import { LazyMarkdown } from 'atoms/markdown/LazyMarkdown';
import { MarkdownDocumentStyleWrapper } from 'atoms/markdown/MarkdownDocumentStyleWrapper';
import { useFetch } from 'hooks/useFetch';
import { fileUrl } from 'lib/gitlab';

type Props = {
  document: string;
  skipHtml?: boolean;
  escapeHtml?: boolean;
};

export const TextDocument = ({
  document,
  skipHtml,
  escapeHtml = true,
}: Props) => {
  const data = useFetch(fileUrl(document));
  return (
    <MarkdownDocumentStyleWrapper>
      <LazyMarkdown data={data} skipHtml={skipHtml} gfm html={!escapeHtml} />
    </MarkdownDocumentStyleWrapper>
  );
};
